import { MapLayerSwitcherOverlays } from "@esdm/map/dist/map/MapLayerSwitcherOverlays"
import { IMap } from "@esdm/map/dist/map/IMap";
import { IMapViewStore } from "@esdm/map/dist/map/store/IMapViewStore"
import { LayerGroupCollections } from "@esdm/map/dist/layers/groups/LayerGroupCollections";
import { IMappingTextPack } from "@esdm/map/dist/resources/MappingTextPack";
import { IVectorLayerGroup } from "@esdm/map/dist/layers/groups/vector/interfaces/IVectorLayerGroup";

import { defaults as interactionDefaults} from 'ol/interaction';
import { defaults as controlDefaults} from 'ol/control';
import View from "ol/View";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import Polygon from "ol/geom/Polygon";
import LineString from "ol/geom/LineString";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import OLMap from 'ol/Map';
import { param } from "jquery";

export class CustomMapLayerSwitcherOverlays extends MapLayerSwitcherOverlays {
    
    constructor(
        private map: IMap,
        private mapStore: IMapViewStore,
        private allLayers: LayerGroupCollections,
        private mappingTextPack: IMappingTextPack) {
        super(map, mapStore, allLayers, mappingTextPack);
    }

    //Modified to insert relative url either to fixed image/svg or MapServer GetLegendGraphic request
    protected addLegendMap = (
        legendMapId: string,
        legendContainer: JQuery<HTMLElement>,
        layerGrp: IVectorLayerGroup): void =>
    {

        switch (layerGrp.ref) {
            case "Monuments": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=MonumentPointsWFS&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            case "HLC": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=HLCPolygonsWFS&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId,layerGrp.ref,imgUrl))
                break;
            }
            case "DoverUAD_AngloSaxon": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=DoverUADAngloSaxonPolygonsWFS&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            case "DoverUAD_EarlyRoman": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=DoverUADEarlyRoman&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            case "DoverUAD_LateRoman": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=DoverUADLateRoman&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            case "DoverUAD_Harbour1500": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=DoverUADHarbour1500PolygonsWFS&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            case "DoverUAD_Medieval": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=DoverUADMedieval&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            case "DoverUAD_PostMedieval1641": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=DoverUADPostMedieval1638to1641PolygonsWFS&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            case "DoverUAD_PostMedieval1865": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=DoverUADPostMedieval1865PolygonsWFS&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }
            case "DoverUAD_PostMedieval1908": {
                legendContainer.empty();
                let imgUrl = "/api/OGCService/hbsmr?service=WMS&request=GetLegendGraphic&version=1.3.0&LAYER=DoverUADPostMedieval1908PolygonsWFS&FORMAT=PNG&SLD_VERSION=1.1.0"
                legendContainer.append(this.getLegendMapElement(legendMapId, layerGrp.ref, imgUrl))
                break;
            }

            default: {
                let newMap = new OLMap({
                    target: legendMapId,
                    controls: controlDefaults({
                        attribution: false,
                        rotate: false,
                        zoom: false
                    }),
                    interactions: interactionDefaults({
                        altShiftDragRotate: false,
                        dragPan: false,
                        doubleClickZoom: false,
                        keyboard: false,
                        mouseWheelZoom: false,
                        shiftDragZoom: false,
                        pinchZoom: false,
                        pinchRotate: false
                    }),
                    view: new View({
                        center: [80, 0],
                        zoom: 16
                    })
                });

                let f = [];
                let pos = 1;

                if (layerGrp.layerLegend.point === true) {
                    f.push(new Feature({
                        geometry: new Point([25, 0])
                    }));
                    pos += 1;
                }

                if (layerGrp.layerLegend.polygon === true) {
                    let x: number;

                    if (pos === 1) {
                        x = 10;
                    } else {
                        x = 66;
                    }
                    f.push(new Feature({
                        geometry: new Polygon([[[x, -20], [x, 20], [x + 40, 20], [x + 40, -20], [x, -20]]])
                    }));
                    pos += 1;
                }

                if (layerGrp.layerLegend.line === true) {
                    let x: number;

                    if (pos === 1) {
                        x = 10;
                    } else if (pos === 2) {
                        x = 70;
                    } else {
                        //pos==3
                        x = 130
                    }

                    f.push(new Feature({
                        geometry: new LineString([[x, 0], [x + 40, 0]])
                    }));
                }

                let vl = new VectorLayer({
                    source: new VectorSource({
                        features: f
                    }),
                    style: layerGrp.style
                });

                newMap.addLayer(vl);
            }
        }
    }

    private getLegendMapElement = (
        legendMapId: string,
        grpRef: string,
        imgUrl: string): JQuery<HTMLElement> => {

        let legendMapElement = $("<div/>", { id: legendMapId, class: "legendGraphic" });
        legendMapElement.append(`<img src="${imgUrl}" alt="Legend graphic for layer ${grpRef}"></img>`);

        return legendMapElement;
    }
}
